<template>
  <div>
    <autoLogout />
    <loader v-if="loader"></loader>
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" />
      <v-card>
        <v-card-text>
          <v-stepper v-model="e1" flat>
            <v-stepper-header>
              <v-stepper-step
                :complete="e1 > 1"
                step="1"
                :rules="[(value) => !!validS1]"
              >
                Información personal
                <small>(Requerido)</small>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                :complete="e1 > 2"
                step="2"
                :rules="[(value) => !!validS2]"
              >
                Información de contacto
                <small>(Requerido)</small>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                :complete="e1 > 3"
                step="3"
                :rules="[(value) => !!validS3]"
              >
                Información de empleado
                <small>(Requerido)</small>
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-container>
                  <validation-observer ref="observer" v-slot="{ invalid }">
                    <v-form
                      v-model="validS1"
                      ref="formPersonalInfo"
                      lazy-validation
                    >
                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Nombre"
                            rules="required|max:60|regex:^[a-zA-ZÀ-ÿ ]+$"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.name"
                              label="Nombre*"
                              :counter="60"
                              :maxlength="60"
                              required
                              :error-messages="errors"
                              @change="autoUserName"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Primer apellido"
                            rules="required|max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.firstLastname"
                              label="Primer apellido*"
                              :counter="60"
                              :maxlength="60"
                              required
                              :error-messages="errors"
                              @change="autoUserName"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Segundo apellido"
                            rules="max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.secondLastname"
                              label="Segundo apellido"
                              :counter="60"
                              :maxlength="60"
                              required
                              :error-messages="errors"
                              @change="autoUserName"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="col-md-4 col-sm-12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="CURP"
                            rules="requiredCurp|curp"
                          >
                            <v-text-field
                              v-model.trim="objAltaPaciente.curp"
                              :counter="18"
                              :maxlength="18"
                              label="CURP*"
                              :error-messages="errors"
                              @input="mayusculas($event)"
                            ></v-text-field>
                          </validation-provider>
                          <p class="caption text--secondary">
                            Si desconoce la CURP utiliza el formato
                            XXXX999999XXXXXX99
                          </p>
                        </v-col>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Nacionalidad"
                            rules="required"
                          >
                            <v-autocomplete
                              v-model="objAltaPaciente.nationality"
                              label="Nacionalidad*"
                              :items="nationality"
                              :item-text="nationality.text"
                              :item-value="nationality.value"
                              required
                              :error-messages="errors"
                              no-data-text="Sin resultados disponibles"
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>
                        <template
                          v-if="
                            objAltaPaciente.nationality &&
                            objAltaPaciente.nationality === 'Otro'
                          "
                        >
                          <v-col cols="3" md="3" sm="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Nombre de Nacionalidad"
                              rules="required|alpha"
                            >
                              <v-text-field
                                v-model="otherNationality"
                                label="Nombre de Nacionalidad*"
                                :error-messages="errors"
                                :counter="50"
                                required
                              >
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                        </template>

                        <!-- <v-col>
                          <v-menu
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Fecha de nacimiento"
                                rules="required"
                              >
                                <v-text-field
                                  id="fechaNac"
                                  v-model="dateFormatted"
                                  label="Fecha de nacimiento*"
                                  hint="Formato DD/MM/YYYY"
                                  prepend-icon="mdi-calendar"
                                  v-bind="attrs"
                                  v-on="on"
                                  :rules="nameRules"
                                  required
                                  :error-messages="errors"
                                  @blur="date = parseDate(dateFormatted)"
                                ></v-text-field>
                              </validation-provider>
                            </template>
                            <v-date-picker
                              v-model="date"
                              :active-picker.sync="activePicker"
                              min="1950-01-01"
                              @change="saveNac"
                              @input="menu1 = false"
                              locale="es"
                              :max-date="new Date()"
                            ></v-date-picker>
                          </v-menu>
                        </v-col> -->
                        <v-col>
                          <!-- <vc-date-picker
                            :max-date="new Date()"
                            color="green"
                            v-model="date"
                          > -->
                          <!-- <template v-slot="{ inputEvents, inputValue }"> -->

                          <validation-provider
                            v-slot="{ errors }"
                            name="Fecha de nacimiento"
                            rules="required"
                          >
                            <v-text-field
                              type="date"
                              v-model="date"
                              :max="new Date().toISOString().split('T')[0]"
                              label="Fecha de nacimiento*"
                              :rules="nameRules"
                              hint="Formato DD/MM/YYYY"
                              required
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                          <!-- </template> -->
                          <!-- </vc-date-picker> -->
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Sexo"
                            rules="required"
                          >
                            <v-select
                              v-model="objAltaPaciente.gender"
                              :item-text="genero.text"
                              :item-value="genero.value"
                              :items="genero"
                              label="Sexo*"
                              required
                              :error-messages="errors"
                              :disabled="genVal"
                            ></v-select>
                          </validation-provider>
                        </v-col>

                        <!--<v-col v-if="objAltaPaciente.idCatalogue==9">-->
                        <v-col v-if="objAltaPaciente.nationality != 'Otro'">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Entidad federativa de nacimiento"
                            rules="required"
                          >
                            <v-autocomplete
                              v-model="objAltaPaciente.birthFederalEntity"
                              label="Entidad federativa de nacimiento*"
                              :items="birthFederalEntities"
                              :item-text="birthFederalEntities.text"
                              :item-value="birthFederalEntities.value"
                              required
                              :error-messages="errors"
                              no-data-text="Sin resultados disponibles"
                              :disabled="entityVal"
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>

                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Estado civil"
                            rules="required"
                          >
                            <v-autocomplete
                              v-model="objAltaPaciente.maritalStatus"
                              :items="estadoCivil"
                              :item-text="estadoCivil.text"
                              :item-value="estadoCivil.value"
                              label="Estado civil*"
                              required
                              :error-messages="errors"
                              no-data-text="Sin resultados disponibles"
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row
                        align="center"
                        justify="space-around"
                        class="mt-20 mb-5"
                      >
                        <v-btn
                          text
                          color="error"
                          @click="$router.push('/usuarios')"
                        >
                          Cancelar <v-icon right>mdi-close</v-icon></v-btn
                        >

                        <v-btn
                          color="primary"
                          @click="
                            e1 = 2;
                            validStep(e1 - 1);
                          "
                          :disabled="invalid || sending"
                        >
                          Siguiente <v-icon right>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-row>
                    </v-form>
                  </validation-observer>
                </v-container>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-container>
                  <validation-observer ref="observer" v-slot="{ invalid }">
                    <v-form
                      v-model="validS2"
                      ref="formContactInfo"
                      lazy-validation
                    >
                      <v-row>
                        <v-col class="col-md-8">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Calle"
                            rules="required|max:100"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.street"
                              :counter="100"
                              :maxlength="100"
                              label="Calle*"
                              required
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Número exterior"
                            rules="required|max:5"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.outdoorNumber"
                              :counter="5"
                              :maxlength="5"
                              label="Número exterior*"
                              required
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Número interior"
                            rules="max:5|required"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.interiorNumber"
                              :counter="5"
                              :maxlength="5"
                              :error-messages="errors"
                              label="Número interior"
                            ></v-text-field>
                          </validation-provider>
                          <p class="caption text--secondary">
                            Si el domicilio no cuenta con número interior
                            utiliza el formato N/D
                          </p>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Código postal*"
                            rules="required|max:5"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.postalCode"
                              :counter="5"
                              :maxlength="5"
                              label="Código postal"
                              :error-messages="errors"
                              required
                              @change="findAddress(false)"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col v-if="!noPostal">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Entidad federativa*"
                            rules="required"
                          >
                            <v-autocomplete
                              v-model="objAltaPaciente.federalEntityKey"
                              label="Entidad federativa de residencia"
                              :error-messages="errors"
                              :items="federalEntities"
                              required
                              auto-select-first
                              :loading="sending"
                              no-data-text="Sin resultados disponibles"
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>

                        <v-col v-if="!noPostal">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Municipio"
                            rules="required"
                          >
                            <v-autocomplete
                              v-model="objAltaPaciente.municipalityKey"
                              label="Municipio*"
                              :items="municipalities"
                              :item-text="municipalities.text"
                              :item-value="municipalities.value"
                              no-data-text="Sin resultados disponibles"
                              required
                              :error-messages="errors"
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>

                        <v-col v-if="!noPostal">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Colonia"
                            rules="required"
                          >
                            <v-combobox
                              v-model="objAltaPaciente.colonyKey"
                              :items="colonies"
                              :item-text="colonies.text"
                              :item-value="colonies.value"
                              :loading="isLoading"
                              label="Colonia*"
                              no-data-text="Sin resultados disponibles"
                              required
                              :error-messages="errors"
                            ></v-combobox>
                          </validation-provider>
                        </v-col>
                        <v-col cols="12" md="3" sm="12" v-if="noPostal">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Entidad federativa"
                            rules="required"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.federalEntityKey"
                              label="Entidad federativa de residencia*"
                              :error-messages="errors"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" md="3" sm="12" v-if="noPostal">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Municipio"
                            rules="required"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.municipalityKey"
                              label="Municipio*"
                              :error-messages="errors"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" md="3" sm="12" v-if="noPostal">
                          <validation-Provider
                            v-slot="{ errors }"
                            name="Colonia"
                            rules="required"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.colonyKey"
                              label="Colonia*"
                              :error-messages="errors"
                              required
                            ></v-text-field>
                          </validation-Provider>
                        </v-col>
                      </v-row>
                      <v-row> </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Correo electrónico"
                            rules="required|max:50|email"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.email"
                              :counter="50"
                              :maxlength="50"
                              label="Correo electrónico*"
                              type="email"
                              required
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                          <p class="caption text--secondary">
                            Si desconoce el correo electrónico utiliza el
                            formato N/D
                          </p>
                        </v-col>

                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Número telefónico"
                            rules="required|max:10|phonenumber|min:10"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.phone"
                              :counter="10"
                              :maxlength="10"
                              label="Número telefónico móvil*"
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                          <!-- <p class="caption text--secondary">
                            Si desconoce el número telefónico utiliza el formato
                            0000000000
                          </p> -->
                        </v-col>

                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Número telefónico fijo"
                            rules="max:10|numeric|min:10"
                          >
                            <v-text-field
                              v-model="objAltaPaciente.homePhone"
                              :counter="10"
                              :maxlength="10"
                              label="Número telefónico fijo"
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row
                        align="center"
                        justify="space-around"
                        class="mt-20"
                      >
                        <v-btn color="secondary" text @click="e1 = 1">
                          <v-icon left>mdi-chevron-left</v-icon> Regresar
                        </v-btn>

                        <v-btn
                          text
                          color="error"
                          @click="$router.push('/usuarios')"
                        >
                          Cancelar <v-icon right>mdi-close</v-icon>
                        </v-btn>

                        <v-btn
                          color="primary"
                          @click="
                            e1 = 3;
                            validStep(e1 - 1);
                          "
                          :disabled="invalid || sending"
                        >
                          Siguiente <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-row>
                    </v-form>
                  </validation-observer>
                </v-container>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-container>
                  <validation-observer ref="observer" v-slot="{ invalid }">
                    <v-form
                      v-model="validS3"
                      ref="formEmployeeInfo"
                      lazy-validation
                    >
                      <v-row class="mb-3">
                        <v-col class="col-md-6 col-sm-12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Nombre de usuario"
                            rules="required|max:50"
                          >
                            <v-text-field
                              v-model.trim="autoUser"
                              :counter="50"
                              :maxlength="50"
                              label="Nombre de usuario*"
                              required
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col class="col-md-6 col-sm-12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Rol"
                            rules="required"
                          >
                            <v-autocomplete
                              v-model="objAltaPaciente.idRole"
                              label="Rol*"
                              :items="roles"
                              :item-text="roles.text"
                              :item-value="roles.value"
                              required
                              :error-messages="errors"
                              no-data-text="Sin resultados disponibles"
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-subheader class="mb-2"
                        >Información de empleado</v-subheader
                      >
                      <v-row>
                        <v-col cols="4" sm="12" md="4" lg="4">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Tipo de personal"
                            rules="required|max:50"
                          >
                            <!--<v-text-field
                              v-model.trim="objAltaPaciente.humanRType"
                              :counter="50"
                              label="Tipo de personal*"
                              required
                              :error-messages="errors"
                            ></v-text-field>-->
                            <v-autocomplete
                              v-model="objAltaPaciente.idPersonalType"
                              label="Tipo de personal*"
                              :items="personalTypeList"
                              :item-text="personalTypeList.text"
                              :item-value="personalTypeList.value"
                              required
                              return-object
                              :error-messages="errors"
                              @change="validType"
                              no-data-text="Sin resultados disponibles"
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>

                        <v-col cols="4" sm="12" md="4" lg="4">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Clave del personal"
                            rules="required|max:20"
                          >
                            <v-text-field
                              v-model.trim="objAltaPaciente.humanRKey"
                              :counter="20"
                              :maxlength="20"
                              label="Clave del personal*"
                              required
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                        <v-col cols="4" sm="12" md="4" lg="4">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Id externo"
                            rules="required|max:10"
                          >
                            <v-text-field
                              v-model.trim="objAltaPaciente.externalId"
                              :maxlength="20"
                              label="Id externo*"
                              required
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                        <v-col cols="4" sm="12" md="4" lg="4">
                          <validation-provider
                            v-slot="{ errors }"
                            name="RFC"
                            rules="max:13|min:12"
                          >
                            <v-text-field                             
                              v-model.trim="objAltaPaciente.rfc"
                              :error-messages="errors"
                              label="RFC*"
                              :counter="13"
                              :maxlength="13"
                              @input="if(objAltaPaciente.rfc)objAltaPaciente.rfc = $event.toUpperCase()"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-divider></v-divider>
                      <v-subheader class="mb-2"
                        >Información como profesional</v-subheader
                      >

                      <v-row class="mb-3">

                        <v-col class="col-md-4 col-sm-12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Institución/Universidad de egreso"
                            rules="max:100|required"
                          >
                            <v-text-field
                              v-model.trim="objAltaPaciente.studyDegree"
                              :counter="100"
                              :maxlength="100"
                              label="Institución/Universidad de egreso"
                              required
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col class="col-md-4 col-sm-12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Nombre de título"
                            rules="max:100"
                          >
                            <v-text-field
                              v-model.trim="objAltaPaciente.titleName"
                              :counter="100"
                              :maxlength="100"
                              label="Nombre de título"
                              required
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col class="col-md-4 col-sm-12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Acrónimo"
                            rules="max:10"
                          >
                            <v-text-field
                              v-model.trim="objAltaPaciente.acronym"
                              :counter="10"
                              :maxlength="10"
                              label="Acrónimo"
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col class="col-md-4 col-sm-12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Número de licencia"
                            rules="max:50"
                          >
                            <v-text-field
                              v-model.trim="objAltaPaciente.professionalLicense"
                              :counter="50"
                              :maxlength="50"
                              label="Número de licencia"
                              :error-messages="errors"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-divider class="mt-5"></v-divider>
                      <v-row>
                        <v-col cols="4">
                          <v-subheader>Asignar Sucursales</v-subheader>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Sucursales"
                          >
                            <v-autocomplete
                              v-model="branchOfficeSelect"
                              label="Seleccione las sucursales"
                              multiple
                              small-chips
                              :items="branchOfficeList"
                              :item-text="branchOfficeList.text"
                              :item-value="branchOfficeList.value"
                              :error-messages="errors"
                              no-data-text="Sin resultados disponibles"
                              required
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>
                        <v-col cols="4">
                          <v-subheader>Asignar Modalidades</v-subheader>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Modalidades"
                          >
                            <v-autocomplete
                              v-model="modalitiesSelect"
                              label="Seleccione las modalidades"
                              multiple
                              small-chips
                              :items="modalitiesList"
                              :item-text="modalitiesList.text"
                              :item-value="modalitiesList.value"
                              :error-messages="errors"
                              no-data-text="Sin resultados disponibles"
                              required
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-divider></v-divider>
                      <v-subheader class="mb-2"
                        >Firma {{ signRequireText }}</v-subheader
                      >
                      <v-row>
                        <v-col class="col-md-4 col-sm-12">
                          <v-col class="col-md-10">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Firma"
                              v-if="validTypePerson"
                              rules="required"
                            >
                              <v-file-input
                                accept="image/png, image/jpeg, image/jpg"
                                placeholder="Seleccione la imagen*"
                                v-model="filesSign"
                                ref="uploadFile"
                                @change="validateSign"
                                @click:append="validateSign"
                                truncate-length="15"
                                dense
                                prepend-icon="mdi-pen"
                                :required="validTypePerson"
                                :error-messages="errors"
                              >
                              </v-file-input>
                            </validation-provider>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Firma"
                              v-if="!validTypePerson"
                            >
                              <v-file-input
                                accept="image/png, image/jpeg, image/jpg"
                                placeholder="Seleccione la imagen"
                                v-model="filesSign"
                                ref="uploadFile"
                                @change="validateSign"
                                @click:append="validateSign"
                                truncate-length="15"
                                dense
                                prepend-icon="mdi-pen"
                                :error-messages="errors"
                              >
                              </v-file-input>
                            </validation-provider>
                          </v-col>
                        </v-col>
                      </v-row>

                      <v-row
                        align="center"
                        justify="space-around"
                        class="mt-20"
                      >
                        <v-btn color="secondary" text @click="e1 = 2">
                          <v-icon left>mdi-chevron-left</v-icon> Regresar
                        </v-btn>
                        <v-btn
                          text
                          color="error"
                          @click="$router.push('/usuarios')"
                        >
                          Cancelar <v-icon right>mdi-close</v-icon>
                        </v-btn>
                        <v-btn
                          color="primary"
                          @click="
                            e1 = 3;
                            saveSignToUser();
                          "
                          :disabled="invalid || sending"
                          >{{ sending ? "Guardando..." : "Guardar"
                          }}<v-icon right>mdi-content-save</v-icon></v-btn
                        >
                      </v-row>
                    </v-form>
                  </validation-observer>
                </v-container>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import {
  UserRequest,
  EnumRequest,
  CatalogueRequest,
  FederalEntityRequest,
  MunicipalityRequest,
  ColonyRequest,
  RoleRequest,
  PersonalTypeRequest,
  SepomexRequest,
  BranchOfficeRequest,
  ModaltyRequest,
} from "@/core/request";
import Sidebar from "../../components/Sidebar.vue";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import {
  required,
  max,
  min,
  numeric,
  alpha_num,
  regex,
} from "vee-validate/dist/rules";
import moment from "moment";
import { mapActions } from "vuex";
import AutoLogout from "../../components/AutoLogout.vue";
import Encabezado from "@/app/components/base/header/Header.vue";

let token = sessionStorage.tokenUser;

extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max", {
  ...max,
  message: "{_field_} no debe ser mayor de {length} caracteres",
});
extend("min", {
  ...min,
  message: "{_field_} no debe ser menor de {length} caracteres",
});
extend("numeric", {
  ...numeric,
  message: "{_field_} debe ser numérico",
});
extend("alpha_num", {
  ...alpha_num,
  message: "{_field_} solo debe contener letras y números",
});
extend("regex", {
  ...regex,
  message: "{_field_} no debe contener caracteres especiales",
});

export default {
  components: {
    Sidebar,
    ValidationProvider,
    ValidationObserver,
    extend,
    AutoLogout,
    Encabezado,
  },
  name: "RegistrarPaciente",
  data: (vm) => ({
    loader: false,
    filesSign: [],
    isLoading: false,
    validS1: false,
    validS2: true,
    validS3: true,
    stepForm: [],
    nameRules: [(v) => !!v || "Campo requerido"],
    encabezado: { icono: "mdi-pencil", texto: "Registrar usuario" },
    e1: 1,
    date: null,
    date2: null,
    date3: null,
    modal: false,
    menu: false,
    menu2: false,
    menu3: false,
    activePicker: null,
    genero: [
      { text: "Femenino", value: "M" },
      { text: "Masculino", value: "H" },
      { text: "No binario", value: "X" },
    ],
    estadoCivil: [],
    birthFederalEntities: [],
    federalEntities: [],
    municipalities: [],
    colonies: [],
    nationality: [
      { text: "Mexicana", value: "Mexicana" },
      { text: "Otra", value: "Otro" },
    ],
    roles: [],
    objAltaPaciente: {
      gender: "",
      birthFederalEntity: "",
    },
    academicTitleList: {},
    sending: false,
    invalidSign: true,
    dataSign: {
      file: null,
      idUser: null,
    },
    date: null,
    dateFormatted: null,
    menu1: false,
    invalidDate: true,
    validAddress: false,
    branchOfficeList: [],
    modalitiesList: [],
    branchOfficeSelect: [],
    modalitiesSelect: [],
    personalTypeList: [],
    validTypePerson: false,
    signRequireText: "",
    otherNationality: "",
    noPostal: false,
    autoUser: "",
    /**validaciones */
    genVal: false,
    entityVal: false,
    birthDateVal: false,
    genericCurp: "XXXX999999XXXXXX99",
  }),
  mounted() {
    let preferences = { theme: false, view_type: false };
    preferences = JSON.stringify(preferences);
    this.validBrowserTab();
    this.listAllEntities();
    this.listMaritalStatus();
    this.listRole();
    this.listAllBranchOffice();
    this.listAllPersonalType();
    this.listAllModalities();
  },
  computed: {
    // computedDateFormatted() {
    //   return this.formatDate(this.date);
    // },
    /*objAltaPaciente(){
      return this.objAltaPaciente.colonyKey
    }*/
  },

  watch: {
    // date(val) {
    //   try {
    //     this.dateFormatted = this.formatDate(this.date);
    //     let result = moment(this.dateFormatted, "DD/MM/YYYY", true).isValid();
    //     let today = moment(new Date()).format("YYYY-MM-DD");
    //     if (result) {
    //       if (this.date < today) {
    //         this.invalidDate = false;
    //         document.getElementById("fechaNac").style = "none";
    //       } else {
    //         this.invalidDate = true;
    //         this.$utilFront.notifications(
    //           "La fecha no puede ser mayor a la fecha actual",
    //           "ERROR"
    //         );
    //         document.getElementById("fechaNac").style.color = "red";
    //       }
    //     } else {
    //       this.invalidDate = true;
    //       this.$utilFront.notifications("Formato de fecha incorrecto", "ERROR");
    //       document.getElementById("fechaNac").style.color = "red";
    //     }
    //   } catch (e) {}
    // },
    /*** Validaciones curp ***/
    /*** @MaudePallares ***/
    "objAltaPaciente.curp": function () {
      this.initCurpValidation();
      if (this.objAltaPaciente.curp == "") {
        this.genVal = false;
        this.entityVal = false;
        this.objAltaPaciente.gender = "";
        this.objAltaPaciente.birthFederalEntity = "";
      }
    },
  },

  methods: {
    /*Funciones para validaciones curp con entidad federativa y genero */
    /*** @MaudePallares ***/
    initCurpValidation() {
      this.gendervalidation();
      this.entityvalidation();
      this.birthdatevalidation();
    },
    gendervalidation() {
      let validate = true;
      let curpgender = this.objAltaPaciente.curp;
      if (this.genericCurp == this.objAltaPaciente.curp) {
        validate = false;
        this.genVal = false;
      }
      if (validate) {
        switch (curpgender.charAt(10)) {
          case "H":
            this.objAltaPaciente.gender = "H";
            this.genVal = true;
            break;
          case "M":
            this.objAltaPaciente.gender = "M";
            this.genVal = true;
            break;
          case "X":
            this.objAltaPaciente.gender = "X";
            this.genVal = true;
            break;
        }
      }
    },
    entityvalidation() {
      let validate = true;
      let entityName = "";
      let entityCurp =
        this.objAltaPaciente.curp.charAt(11) +
        this.objAltaPaciente.curp.charAt(12);
      if (this.objAltaPaciente.curp == this.genericCurp) {
        validate = false;
        this.entityVal = false;
      }
      if (validate) {
        for (let i in this.birthFederalEntities) {
          if (this.birthFederalEntities[i].entitykey == entityCurp) {
            entityName = this.birthFederalEntities[i].text;
          }
        }
        this.objAltaPaciente.birthFederalEntity = entityName;
        this.entityVal = true;
      }
    },
    /******************************************************************************************************** */
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    colonia(e) {
      let colonia = e;
      this.objAltaPaciente.colonyKey = colonia;
      return colonia;
    },
    mayusculas(e) {
      if (this.objAltaPaciente.curp) {
        this.objAltaPaciente.curp = e.toUpperCase();
      }
    },
    listAllModalities() {
      ModaltyRequest.allModality().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.modalitiesList = res.data.data.map((modality) => {
            return {
              text: modality.acronym + " - " + modality.name,
              value: modality.idModality,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    findAddress() {
      this.sending = true;

      this.colonies = [];
      this.municipalities = [];
      this.federalEntities = [];

      let postalCode = this.objAltaPaciente.postalCode;

      this.objAltaPaciente.federal = "";
      this.objAltaPaciente.municipalityKey = "";
      this.objAltaPaciente.federalEntityKey = "";

      SepomexRequest.listAllByPostalCode({ postalCode: `${postalCode}` })
        .then((res) => {
          let { data, response, message } = res.data;

          if (response) {
            this.noPostal = false;
            this.federalEntities = data
              .map((it) => {
                return it.federalEntity;
              })
              .filter(this.onlyUnique);
            this.municipalities = data
              .map((it) => {
                return it.municipality;
              })
              .filter(this.onlyUnique);
            this.colonies = data
              .map((it) => {
                return it.settlement;
              })
              .filter(this.onlyUnique);

            this.objAltaPaciente.federalEntityKey = this.federalEntities[0];
            this.objAltaPaciente.municipalityKey = this.municipalities[0];
            this.objAltaPaciente.colonyKey = this.colonies[0];
          } else {
            this.noPostal = true;
            this.$utilFront.notifications(
              "Código postal no registrado, capturar manualmente.",
              "WARNING"
            );
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },

    catchError(e) {
      this.$utilFront.notifications("Ha ocurrido un error interno.", "ERROR");
    },

    // formatDate(date) {
    //   if (!date) return null;

    //   const [year, month, day] = date.split("-");
    //   return `${day}/${month}/${year}`;
    // },

    // parseDate(date) {
    //   if (!date) return null;

    //   const [day, month, year] = date.split("/");
    //   return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    // },

    addSign(value, fieldType) {
      fieldType.push({ value: "" });
    },
    removeSign(index, fieldType) {
      type.splice(index, 1);
    },

    save(date4) {
      this.$refs.menu.save(date4);
    },
    saveNac(date) {
      this.$refs.menu2.save(date);
    },
    saveDef(date3) {
      this.$refs.menu3.save(date3);
    },
    validStep(n) {
      switch (n) {
        case 1:
          this.$refs.formPersonalInfo.validate();
          break;
        case 2:
          this.$refs.formEmployeeInfo.validate();
          break;
        case 3:
          this.$refs.formContactInfo.validate();
          break;
      }
    },
    /*cleanModal(n) {
      this.dialog = !this.dialog;

      this.$refs.formPersonalInfo.reset();
      this.$refs.formPersonalInfo.resetValidation();

      this.$refs.formEmployeeInfo.reset();
      this.$refs.formEmployeeInfo.resetValidation();

      this.$refs.formContactInfo.reset();
      this.$refs.formContactInfo.resetValidation();

      this.$refs.formID.reset();
      this.$refs.formID.resetValidation();

      this.e1 = 1;
      this.$router.go(-1);
    },*/

    birthdatevalidation() {
      let validate = true;
      if (this.genericCurp == this.objAltaPaciente.curp) {
        validate = false;
      }
      if (validate) {
        let currentyear = moment().local().format("YY");
        let birthyear =
          this.objAltaPaciente.curp.charAt(4) +
          this.objAltaPaciente.curp.charAt(5);
        let birthYearCurp =
          birthyear > currentyear ? "19" + birthyear : "20" + birthyear;
        let birthDateCurp =
          birthYearCurp +
          "-" +
          this.objAltaPaciente.curp.charAt(6) +
          this.objAltaPaciente.curp.charAt(7) +
          "-" +
          this.objAltaPaciente.curp.charAt(8) +
          this.objAltaPaciente.curp.charAt(9);

        this.date = birthDateCurp;
      }
    },

    addUser() {
      if (!this.loader) {
        this.loader = true;
        this.sending = true;
        let enti;
        let nan;
        let userData = this.objAltaPaciente;
        let preferences = { theme: false, view_type: false };
        preferences = JSON.stringify(preferences);

        if (
          userData.titleName ||
          userData.acronym ||
          userData.professionalLicense
        ) {
          this.academicTitleList = {
            name: userData.titleName ? userData.titleName : "",
            acronym: userData.acronym ? userData.acronym : "",
            professionalLicense: userData.professionalLicense
              ? userData.professionalLicense
              : "",
          };
        } else {
          this.academicTitleList = null;
        }
        if (userData.nationality === "Otro") {
          enti = "Ninguno";
          nan = this.otherNationality;
        } else {
          enti = userData.birthFederalEntity;
          nan = userData.nationality;
        }

        let postRegisterUser = {
          username: this.autoUser,
          password: userData.email,
          preferences: preferences,
          role: {
            idRole: userData.idRole,
          },
          personalType: {
            idPersonalType: userData.idPersonalType.value,
          },
          humanResourceType: userData.humanRType,
          humanResourceKey: userData.humanRKey,
          externalId: userData.externalId,
          academicTitleList: this.academicTitleList,
          sign: this.dataSign.file,
          branchOfficeList: this.branchOfficeSelect,
          rfc: userData.rfc,
          studyDegree: userData.studyDegree,
          modalitiesList: this.modalitiesSelect,
          person: {
            name: userData.name,
            firstLastname: userData.firstLastname,
            secondLastname: userData.secondLastname,
            curp: userData.curp,
            gender: userData.gender,
            birthDate: moment(this.date).startOf("day"),
            birthFederalEntity: enti,
            maritalStatus: userData.maritalStatus,
            contactInformation: {
              email: userData.email,
              phone: userData.phone,
              homePhone: userData.homePhone,
            },
            branchOffice: {
              idBranchOffice: this.$utilFront.getIdBranchOffice(),
            },
            address: {
              interiorNumber: userData.interiorNumber,
              outdoorNumber: userData.outdoorNumber,
              postalCode: userData.postalCode,
              street: userData.street,
              federalEntityKey: userData.federalEntityKey,
              municipalityKey: userData.municipalityKey,
              colonyKey: userData.colonyKey,
            },
            nationality: nan,
            disability: 1,
            indigenousLanguage: 0,
          },
        };

        if (
          this.$refs.formPersonalInfo.validate() &&
          this.$refs.formEmployeeInfo.validate() &&
          this.$refs.formContactInfo.validate()
        ) {
          try {
            UserRequest.addUser(postRegisterUser)
              .then((res) => {
                if (res.data.data) {
                  if (res.data.code === 200 && res.data.status === "OK") {
                    this.$utilFront.notifications(
                      "Usuario registrado correctamente",
                      "SUCCESS"
                    );
                    this.$router.push("/usuarios");
                  } else if (res.data.code === 401) {
                    this.unauthorized();
                  } else {
                    if (typeof res.data.data == "string") {
                      this.$utilFront.notifications(res.data.data, "ERROR");
                    } else {
                      this.$utilFront.notifications(
                        "Error al registrar el usuario, intente nuevamente",
                        "ERROR"
                      );
                    }
                  }
                }
              })
              .catch((e) => {
                //console.log(e)
                this.$utilFront.notifications(
                  "Ha ocurrido un error interno",
                  "ERROR"
                );
              })
              .finally(() => {
                this.sending = false;
                this.loader = false;
              });
          } catch (e) {
            this.catchError(e);
          }
        }
      }
    },
    listAllEntities() {
      FederalEntityRequest.listAllFederalEntity({
        headers: { Authorization: token },
      }).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.federalEntities = res.data.data.map((entity) => {
            return {
              text: entity.name,
              value: entity.idFederalEntity,
            };
          });
          this.birthFederalEntities = res.data.data.map((birthEntity) => {
            return {
              text: birthEntity.name,
              value: birthEntity.name,
              entitykey: birthEntity.federalEntityKey,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    listAllMunicipitiesByFederalEntity() {
      let idFederalEntity = this.objAltaPaciente.federalEntityKey;
      MunicipalityRequest.listAllMunicipality(
        { federalEntity: { idFederalEntity: idFederalEntity } },
        { headers: { Authorization: token } }
      ).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.municipalities = res.data.data.map((fMunility) => {
            return {
              text: fMunility.name,
              value: fMunility.idMunicipality,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAllColoniesByMunicipality() {
      this.isLoading = true;
      let idMunicipality = this.objAltaPaciente.municipalityKey;

      ColonyRequest.listAllColony(
        { municipality: { idMunicipality: idMunicipality } },
        { headers: { Authorization: token } }
      ).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.colonies = res.data.data.map((colony) => {
            this.isLoading = false;
            return {
              text: colony.name,
              value: colony.idColony,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listMaritalStatus() {
      EnumRequest.listAllMaritalStatus({
        headers: { Authorization: token },
      }).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.estadoCivil = res.data.data.map((status) => {
            return {
              text: status.text,
              value: status.value,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listRole() {
      RoleRequest.listAllRoles().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          let statusRol = res.data.data.filter((rol) => rol.status == 1);
          this.roles = statusRol.map((role) => {
            return {
              text: role.name,
              value: role.idRole,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    listAllBranchOffice() {
      BranchOfficeRequest.listAllBranchOffice2().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.branchOfficeList = res.data.data.map((entity) => {
            return {
              text: entity.name,
              value: entity.idBranchOffice,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    validateSign(value) {
      this.invalidSign = true;
      try {
        if (this.filesSign) {
          let formats = ["image/png", "image/jpeg", "image/jpg"];
          let typeFile = this.filesSign.type;
          let isValidFormat = formats.find((format) => {
            return typeFile == format;
          });
          if (isValidFormat) {
            this.invalidSign = false;
          } else {
            this.$utilFront.notifications(
              `Formato ${typeFile} no admitido.`,
              "ERROR"
            );
            this.filesSign = undefined;
          }
        }
      } catch (error) {
        this.catchError(error);
      }
    },
    getBase64(file) {
      let reader = new FileReader();
      let fileByte = [];
      reader.readAsArrayBuffer(file);
      reader.onload = (evt) => {
        if (evt.target.readyState == FileReader.DONE) {
          let arrayBuffer = evt.target.result,
            array = new Uint8Array(arrayBuffer);
          for (let byte of array) {
            fileByte.push(byte);
          }
        }
        this.dataSign.file = fileByte;
        this.dataSign.idUser = this.$route.params.id;
        this.addUser();
      };
      reader.onerror = function (error) {};
    },
    saveSignToUser() {
      if (this.filesSign != null && this.filesSign.length != 0) {
        this.getBase64(this.filesSign);
      } else {
        this.addUser();
      }
    },

    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },

    listAllPersonalType() {
      PersonalTypeRequest.listAllPersonalType().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.personalTypeList = res.data.data.map((entity) => {
            return {
              text: entity.name,
              value: entity.idPersonalType,
              signRequired: entity.requiresSignature,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    validType(item) {
      this.validTypePerson = item.signRequired == 0 ? false : true;
      this.$refs.formEmployeeInfo.validate();
    },
    autoUserName() {
      let u1 = "";
      let u2 = "";
      let u3 = "";
      if (
        this.objAltaPaciente.name != null &&
        this.objAltaPaciente.name.length > 2
      ) {
        u1 = this.objAltaPaciente.name.substring(0, 2);
      }
      if (
        this.objAltaPaciente.firstLastname != null &&
        this.objAltaPaciente.firstLastname.length > 2
      ) {
        u2 = this.objAltaPaciente.firstLastname.substring(0, 2);
      }
      if (
        this.objAltaPaciente.secondLastname != null &&
        this.objAltaPaciente.secondLastname.length > 2
      ) {
        u3 = this.objAltaPaciente.secondLastname.substring(0, 2);
      }
      this.autoUser = (u1 + u2 + u3)
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
  },
};
</script>